import styles from "./GridBackdrop.module.css";

/** The backdrop behind every page: a lavender shade fading from the top of the page to the
 * bottom, under a faint square grid (indigo on navy in the dark theme). */
export function GridBackdrop() {
  return <div className={styles.scene} aria-hidden="true" />;
}
